import React from 'react';
import { Nav } from 'react-bootstrap';

interface ModalTabsProps {
    tab: string;
    tabs?: string[];
    setTab: (value: ((prevState: string) => string) | string) => void;
}

export function ModalTabs({
    tab,
    tabs = ['Info', 'Reminders', 'Notes', 'History'],
    setTab,
}: ModalTabsProps) {
    return (
        <div className="card-header">
            <Nav variant="tabs" className="card-header-tabs">
                {tabs!.map((x) => (
                    <Nav.Item key={x}>
                        <Nav.Link className={x === tab ? 'active' : ''} onClick={() => setTab(x)}>
                            {x}
                        </Nav.Link>
                    </Nav.Item>
                ))}
            </Nav>
        </div>
    );
}
